import React, { useContext, useState, useRef, useEffect } from "react";
import Category from "./Category";
import "./Categories.css";
import { Link } from "react-router-dom";
import { HerracContext } from "../../../App";
import { FaChevronRight, FaTimes, FaFire } from "react-icons/fa";

// ============================================
// URL FORMATLASDıRMA FUNKSİYASI
// ============================================
function formatUrlString(str) {
    if (!str) return "";
    const azerbaijaniMap = {
        "ə": "e", "ş": "s", "ğ": "g", "ü": "u", "ö": "o", "ç": "c", "ı": "i",
        "Ə": "E", "Ş": "S", "Ğ": "G", "Ü": "U", "Ö": "O", "Ç": "C", "I": "I"
    };
    return str
        .toLowerCase()
        .replace(/[əşıöğüçƏŞİÖĞÜÇ]/g, match => azerbaijaniMap[match] || match)
        .replace(/\s+/g, "-")
        .replace(/[^\w-]+/g, "");
}

// ============================================
// SKELETON LOADER COMPONENT
// ============================================
function CategorySkeleton() {
    return (
        <div className="herrac-category herrac-category--skeleton">
            <div className="herrac-category__image herrac-skeleton-image">
                <div className="herrac-skeleton-shimmer"></div>
            </div>
            <div className="herrac-category__name herrac-skeleton-text"></div>
            <div className="herrac-category__badge herrac-skeleton-badge"></div>
        </div>
    );
}

// ============================================
// CATEGORIES COMPONENT
// ============================================
function Categories() {
    const {
        categoriesData,
        setSelectedCategory,
        setSelectedSubcategory,
        loading
    } = useContext(HerracContext);

    const [activeCategory, setActiveCategory] = useState(null);
    const [showScrollHint, setShowScrollHint] = useState(true);
    const scrollRef = useRef(null);

    // ============================================
    // SCROLL HINT KONTROLU
    // ============================================
    useEffect(() => {
        const handleScroll = () => {
            if (scrollRef.current && scrollRef.current.scrollLeft > 20) {
                setShowScrollHint(false);
            }
        };

        const scrollElement = scrollRef.current;
        if (scrollElement) {
            scrollElement.addEventListener('scroll', handleScroll);
        }

        return () => {
            if (scrollElement) {
                scrollElement.removeEventListener('scroll', handleScroll);
            }
        };
    }, []);

    // ============================================
    // ALT KATEQORİYALARI AÇMA/BAĞLAMA
    // ============================================
    const toggleAltCategories = (id) => {
        if (activeCategory?.id === id) {
            setActiveCategory(null);
        } else {
            const findCategory = categoriesData.find((item) => item.id === id);
            setActiveCategory(findCategory);
        }
    };

    // ============================================
    // ALT KATEQORİYA SEÇİMİ
    // ============================================
    const selectSubCategory = (subId) => {
        setSelectedSubcategory(subId);
        setActiveCategory(null);
    };

    // ============================================
    // ƏSAS KATEQORİYA SEÇİMİ
    // ============================================
    const selectMainCategory = () => {
        setSelectedCategory(activeCategory.id);
        setSelectedSubcategory(null);
        setActiveCategory(null);
    };

    // ============================================
    // MODAL BAĞLAMA
    // ============================================
    const closeSubcategories = () => {
        setActiveCategory(null);
    };

    return (
        <div className="herrac-categories-wrapper">
            <div className="herrac-categories-container">
                
                {/* ============================================
                    BAŞLIQ
                ============================================ */}
                <div className="herrac-categories-header">
                    <FaFire className="herrac-categories-header__icon" />
                    <h2 className="herrac-categories-header__title">
                        Aktiv Hərrac Kateqoriyaları
                    </h2>
                </div>

        

                {/* ============================================
                    KATEQORİYALAR GRİD / CAROUSEL
                ============================================ */}
                <div className="herrac-categories-grid" ref={scrollRef}>
                            {/* ============================================
                    SCROLL HINT (Mobil)
                ============================================ */}
                {!loading && categoriesData.length > 3 && showScrollHint && (
                    <div className="herrac-categories-scroll-hint">
                        <FaChevronRight />
                    </div>
                )}
                    {loading ? (
                        // Loading zamanı skeleton göstər
                        Array.from({ length: 6 }).map((_, index) => (
                            <CategorySkeleton key={index} />
                        ))
                    ) : categoriesData && categoriesData.length > 0 ? (
                        // Real kateqoriyalar
                        categoriesData.map((item) => (
                            <Category 
                                key={item.id} 
                                {...item} 
                                toggleAltCategories={toggleAltCategories} 
                            />
                        ))
                    ) : (
                        // Boş vəziyyət
                        <div className="herrac-categories-empty">
                            <p>Kateqoriya tapılmadı</p>
                        </div>
                    )}
                </div>

                {/* ============================================
                    ALT KATEQORİYALAR MODAL
                ============================================ */}
                {activeCategory && (
                    <>
                        {/* Overlay */}
                        <div 
                            className="herrac-subcategories-overlay" 
                            onClick={closeSubcategories}
                        ></div>
                        
                        {/* Modal */}
                        <div className="herrac-subcategories-modal">
                            
                            {/* Modal Header */}
                            <div className="herrac-subcategories-header">
                                <div className="herrac-subcategories-header__left">
                                    <img 
                                        src={`https://api.herracim.az/HerracImages/categoriesImages/${activeCategory.image}`} 
                                        alt={activeCategory.name}
                                        className="herrac-subcategories-header__image"
                                        onError={(e) => {
                                            e.target.style.display = 'none';
                                        }}
                                    />
                                    <h3>{activeCategory.name}</h3>
                                </div>
                                <button 
                                    className="herrac-subcategories-close"
                                    onClick={closeSubcategories}
                                    aria-label="Bağla"
                                >
                                    <FaTimes />
                                </button>
                            </div>

                            {/* Modal Content */}
                            <div className="herrac-subcategories-content">
                                
                                {/* Bütün Hərraclar Linki */}
                                <Link
                                    to={`/elanlar/${formatUrlString(activeCategory.name)}`}
                                    className="herrac-subcategories-all"
                                    onClick={selectMainCategory}
                                >
                                    <FaChevronRight />
                                    <span>Bütün {activeCategory.name} Hərracları</span>
                                    <span className="herrac-subcategories-all__badge">
                                        Hamısı
                                    </span>
                                </Link>

                                {/* Alt Kateqoriyalar Grid */}
                                {activeCategory?.subCategories && activeCategory.subCategories.length > 0 ? (
                                    <div className="herrac-subcategories-grid">
                                        {activeCategory.subCategories.map((item) => (
                                            <Link
                                                key={item.id}
                                                to={`/elanlar/${formatUrlString(activeCategory.name)}/${formatUrlString(item.name)}`}
                                                className="herrac-subcategory-card"
                                                onClick={() => selectSubCategory(item.id)}
                                            >
                                                <FaChevronRight className="herrac-subcategory-card__icon" />
                                                <span className="herrac-subcategory-card__name">
                                                    {item.name}
                                                </span>
                                            </Link>
                                        ))}
                                    </div>
                                ) : (
                                    <div className="herrac-subcategories-empty">
                                        <p>Alt kateqoriya mövcud deyil</p>
                                    </div>
                                )}
                            </div>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
}

export default Categories;